import { render, staticRenderFns } from "./CustomPagination.vue?vue&type=template&id=cdfbea0c&"
import script from "./CustomPagination.vue?vue&type=script&lang=js&"
export * from "./CustomPagination.vue?vue&type=script&lang=js&"
import style0 from "./CustomPagination.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports